/**
 * Deep links into the map.
 *
 * The app has no per-voter route: voter detail is a panel inside the map,
 * opened by selecting a pin. `/map?voter=<id>` is the one URL that opens a
 * named voter, so the admin dashboards' write-in table can link to a voter.
 */
export function voterIdFromQuery(qs: string | null): string | null {
  if (!qs) return null;
  const id = new URLSearchParams(qs).get('voter')?.trim();
  return id ? id : null;
}
